import styled from "styled-components/macro";
import {
  darkGrey,
  brightBlue,
  alertColor,
  lightGrey,
  medBlue,
  lightText,
  darkModeTextColor,
  darkModeCardBorderColor,
  darkModeBackgroundHoveredColor,
  darkModeModalBackgroundColor,
} from "../../../../constants/colors";
import { GRID_GAP, TILE_WIDTH_PX_SM } from "../../../../constants/constants";
import { responsiveFontSize } from "../ProcessTile/ProcessTileStyles";

export const GroupTileStyles = styled.div<{
  $isDarkMode: boolean;
  $isLargeTiles: boolean;
  $tileWidth?: number;
  $tileWidthConfig?: number;
}>`
  button {
    padding: 0 !important;
    text-transform: none !important;
    font-family: "Open Sans", sans-serif !important;
    display: flex;
  }
  .group-tile {
    text-align: center;
    height: ${props =>
      props.$isLargeTiles && props.$tileWidth
        ? props.$tileWidth
        : TILE_WIDTH_PX_SM}px;
    width: ${props =>
      props.$isLargeTiles && props.$tileWidth
        ? props.$tileWidth
        : (props.$tileWidthConfig ?? 1) * TILE_WIDTH_PX_SM}px;
    padding: 0;
    @media all and (-ms-high-contrast: none) {
      margin: ${GRID_GAP / 4}px;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid
      ${({ $isDarkMode }) => ($isDarkMode ? darkModeCardBorderColor : medBlue)};
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeModalBackgroundColor : lightText};
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : darkGrey)};
    position: relative;
  }
  .group-tile:hover {
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeBackgroundHoveredColor : lightGrey};
  }

  .group-name {
    padding: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 0.1)};
    padding-top: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 0.25)};
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1.15)};
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    width: 100%;
    height: 38%;
  }

  .group-performance {
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 2.6)};
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    top: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1)};
    bottom: 0;
  }

  .group-output {
    position: absolute;
    top: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1.2)};
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .group-output-quantity {
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1.8)};
    font-weight: 600;
    height: 45%;
  }

  .group-output-label {
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1)};
  }

  .group-call-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* margin-top: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, -0.2)}; */
    width: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 2.5)};
    fill: ${brightBlue};
    stroke: ${brightBlue};
  }
  .group-call-time {
    position: absolute;
    bottom: 0;
  }

  .group-call-state-elapsed {
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 1.4)};
    font-weight: 500;
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : darkGrey)};
  }
  .group-call-state-elapsed-units {
    padding-left: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 0.3)};
    font-size: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 0.8)};
  }

  .group-alert-icon {
    width: 25%;
    position: absolute;
    bottom: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, -0.3)};
    right: ${props =>
      responsiveFontSize(props.$isLargeTiles, props.$tileWidth, 0.5)};
    fill: ${alertColor};
    stroke: ${alertColor};
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* https://philipnewcomer.net/2014/04/target-internet-explorer-10-11-css/ */
      /* IE10+ CSS styles go here */
      bottom: ${props =>
        responsiveFontSize(props.$isLargeTiles, props.$tileWidth, -3.6)};
    }
  }
`;
